(function () {
  'use strict';
  function initialise(root) {
    if (root.dataset.bpInitialised) return;
    root.dataset.bpInitialised = 'true';
    const form = root.querySelector('[data-bp-facet-form]');
    const toggle = root.querySelector('[data-bp-filter-toggle]');
    const filters = root.querySelector('[data-bp-filters]');
    const mobile = window.matchMedia('(max-width: 749px)');
    if (!form || !toggle || !filters) return;
    function layout() {
      toggle.hidden = !mobile.matches;
      filters.hidden = mobile.matches && toggle.getAttribute('aria-expanded') !== 'true';
    }
    toggle.addEventListener('click', () => {
      toggle.setAttribute('aria-expanded', String(toggle.getAttribute('aria-expanded') !== 'true'));
      layout();
    });
    root.querySelector('[data-bp-sort]')?.addEventListener('change', () => form.requestSubmit());
    form.addEventListener('submit', () => {
      // Empty prices do not need query parameters. Checked filters and sort stay
      // in this one form, so changing sort never discards the current filters.
      form.querySelectorAll('input[type="number"]').forEach(input => { if (!input.value) input.disabled = true; });
    });
    mobile.addEventListener('change', layout);
    layout();
  }
  function start(scope) { scope.querySelectorAll('[data-bp-collection]').forEach(initialise); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(document));
  else start(document);
  document.addEventListener('shopify:section:load', event => start(event.target));
})();
